import React, { useState } from "react";
import "./PlanogramHome.css";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  useMediaQuery,
} from "@mui/material";
import { PlanoButton, PlanoTypography } from "../../../Common";
import { BiStoreAlt } from "react-icons/bi";

const PlanogramHome = ({
  screen,
  setScreen,
  visualisationData = [],
  functionSetSelectedVisualisationData,
}) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm")); // Adjust breakpoint as needed

  const [visualisationValue, setVisualisationValue] = useState("");
  const handleScreenChange = (loggerName) => {
    functionSetSelectedVisualisationData(loggerName);
    setScreen("visualisation");
  };

  return (
    <Box display={!isSmallScreen && "flex"} justifyContent={"space-between"}>
      <Box
        width={isSmallScreen ? "auto" : "30%"}
        bgcolor={"white"}
        p={isSmallScreen ? 1 : 2}
        height={"777px"}
        borderRadius={"12px"}
        position={"relative"}
        sx={{
          boxShadow:
            "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
        }}
      >
        <Box textAlign={"center"}>
          <PlanoButton
            css={{
              fontSize: " 24px",
              fontWeight: "400",
              lineHeight: "36px",
              letterSpacing: "0em",
              backgroundColor: "white",
              color: "black",
              ":hover": { backgroundColor: "white" },
            }}
          >
            Generate Visualisation
          </PlanoButton>
        </Box>

        <Box>
          <FormControl
            fullWidth
            variant="filled"
            sx={{
              marginTop: "1rem",
              borderRadius: "20px",
            }}
            size="small"
          >
            <InputLabel
              sx={{
                color: "black",
                display: "flex",
              }}
            >
              <span>
                <BiStoreAlt
                  style={{
                    marginRight: 8,
                    marginTop: 1,
                    color: "black",
                    fontSize: "1.3rem",
                  }}
                />
              </span>
              <span>Select Type</span>
            </InputLabel>
            <Select
              value={visualisationValue}
              label={visualisationValue}
              onChange={(e) => {
                setVisualisationValue(e.target.value);
                handleScreenChange(e.target.value);
              }}
              sx={{
                borderRadius: "8px",
                backgroundColor: "#f3f7f9",
              }}
            >
              {visualisationData &&
                visualisationData?.map((elem, index) => (
                  <MenuItem value={elem} key={index}>
                    {elem.logger_name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          <br />

          <br />
          <PlanoButton>Next</PlanoButton>
        </Box>
      </Box>

      <Box width={isSmallScreen ? "auto" : "58%"} p={2}>
        <PlanoTypography
          css={{
            fontSize: "24px",
            marginBottom: "2rem",
          }}
        >
          How to create Visualisation ?
        </PlanoTypography>
        <Box
          height={"500px"}
          borderRadius={"16px"}
          mb={2}
          bgcolor={"#7240FE"}
          textAlign={"center"}
          color={"white"}
        >
          <iframe
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/ItuDDEAvx8M?si=tsFL0iIJxAj2IPAF"
            title="Planogram Image Generation"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </Box>
      </Box>
    </Box>
  );
};

export default PlanogramHome;
